/*
 * Name: Featured Suppliers
 * Desc:
 *
 */
import React from "react"
import { Image } from "react-datocms"
import SocialLinks from "@components/global/SocialLinks/SocialLinks"
import Section from "@components/structure/Section/Section"
import SiteWrapper from "@components/structure/SiteWrapper/SiteWrapper"
import noProfileImage from "@images/noProfileImage.jpg"
import * as styles from "./AuthorBio.module.scss"

const AuthorBio = ({ name = "", description = "", facebook, twitter, instagram, image }) => (
  <Section className={styles.AuthorBio}>
    <SiteWrapper textNarrow className={styles.grid}>
      <div className={styles.profile}>
        <div className={styles.profileImage}>
          {image ? <Image data={image.responsiveImage} lazyLoad={false} /> : <img src={noProfileImage} alt="" />}
        </div>
        <div className={styles.profileInfo}>
          <h3>Author</h3>
          <span>{name}</span>
          <div className={styles.social}>
            <SocialLinks facebook={facebook} twitter={twitter} instagram={instagram} />
          </div>
        </div>
      </div>
      <div className={styles.text} dangerouslySetInnerHTML={{ __html: description }} />
    </SiteWrapper>
  </Section>
)

export default AuthorBio
